import { useEffect, useState } from "react";
import useFetch from 'use-http';
import config from "../../../config";
import { ArrowUpCircleIcon, BoltIcon, CloudIcon, CloudArrowUpIcon, VariableIcon, SparklesIcon, CheckCircleIcon, ExclamationCircleIcon, CodeBracketIcon, SquaresPlusIcon } from '@heroicons/react/24/outline';
import PageHeading from "../Base/Elements/Nav/PageHeading";
import moment from 'moment';
import MaximumNumberWorkflowsAlert from "../Base/Elements/Alerts/MaximumNumberWorkflowsAlert";
import EnvironmentDropdown from "../Base/Elements/Nav/EnvironmentDropdown";
import ActionButton from "../Base/Elements/Nav/ActionButton";
import ConfirmModal from "../Base/Elements/Confirmations/ConfirmModal";

export default function WorkflowsGrid(props: any) {
  const { post, response, loading } = useFetch(config.url);
  const [workflows, setWorkflows] = useState([]);
  const [selectedFlow, setSelectedFlow] = useState({events: [], flowName: '', SK: '', environment: ''});
  const [showAccessAlert, setShowAccessAlert] = useState(false);
  const [currentWorkflow, setCurrentWorkflow] = useState({flowName: ''});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEnvironment, setSelectedEnvironment] = useState(props.selectedEnvironment);
  const [selectedWorkspace, setSelectedWorkspace] = useState(props.selectedWorkspace);

  useEffect(() => {
    console.dir(props.selectedEnvironment.name);
    setSelectedEnvironment(props.selectedEnvironment);
    setSelectedWorkspace(props.selectedWorkspace);
    getWorkflows();
  }, [JSON.stringify(props.selectedWorkspace), JSON.stringify(props.SelectedEnvironment)]);

  const updateEnvironment = (env: any) => {
    setSelectedEnvironment(env);
    props.setSelectedEnvironment(env);
    getWorkflows();
  }

  const getWorkflows = async () => {
    const body = { 
      selectedWorkspace, 
      selectedEnvironment 
    };
    if (!body.selectedEnvironment) return;
    const workflowsRequest: any = await post(`workflow/list-workflows/${props.user.attributes.id}`, body);
    if (response.ok && workflowsRequest) {
      const workflows = workflowsRequest.workflows.filter((workflow: any) => { 
        if (workflow?.workspace?.SK == selectedWorkspace.SK || workflow?.workspaceId == selectedWorkspace.SK) return workflow;
      });;
      setWorkflows(workflows ? workflows : []);
    } else {
      setWorkflows([]);
    }
  }

  const closeProdRequiredAlert = () => {
    setShowAccessAlert(false);
  }

  const canDelete = () => {
    const hasUpdateWorkflowInSelectedWorkspace = selectedWorkspace.accounts.filter(
      (account: any) => {
        if (account.PK && account.permissions.workflows.delete) return account;
      }
    );
    const isWorkspaceOwner =
      selectedWorkspace.owner.email === props.user.account.email;
    if (
      props.admin === true ||
      hasUpdateWorkflowInSelectedWorkspace.length ||
      isWorkspaceOwner
    ) {
      return true;
    }
    return false;
  }
  /**
   * The function `editFlow` is an asynchronous function that takes a `flow` parameter and calls the
   * `loadWorkflow` function from the `props` object with the `flow` parameter.
   * @param {any} flow - The `flow` parameter is an object that represents a workflow.
   */
  const editFlow = async (flow: any) => { 
    await props.loadWorkflow(flow) 
  }
  /**
   * The function `deleteWorkflow` deletes a workflow if the user has permission and updates the list
   * of workflows.
   * @param {any} flow - The `flow` parameter is an object that represents a workflow. It is passed to
   * the `deleteWorkflow` function to specify which workflow should be deleted.
   */
  const deleteWorkflow = async (flow: any) => {
    if (canDelete()) {
      const body = { selected: selectedEnvironment, flow };
      const deleteRequest = await post(`workflow/delete-workflow/${props.user.attributes.id}`, body);
      if (response.ok && deleteRequest) await getWorkflows();
    }
  }
  /**
   * The function `openModal` sets the current tunnel and opens a modal.
   * @param {any} tunnel - The `tunnel` parameter is of type `any`, which means it can accept any data
   * type.
   */
  const openModal = (workflow: any) => {
    setCurrentWorkflow(workflow);
    setIsModalOpen(true);
  };
  
 /**
  * The closeModal function sets the state variable isModalOpen to false.
  */
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  /**
   * The function `confirmDelete` deletes a stack in the current environment and closes a modal.
   */
  const confirmDelete = () => {
    deleteWorkflow(currentWorkflow);
    closeModal();
  };
  const viewEvents = (flow: any) => {
    if (flow.events) {
      flow.events.map((event: any) => {
        if (event.type === 'T-101' || event.type === 101) {
          event.icon = <VariableIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-gray-100" aria-hidden="true" />
        }
        if (event.type === 'T-111') {
          event.icon = <VariableIcon className="rounded-lg h-8 w-8 bg-orange-500 text-gray-100" aria-hidden="true" />
        }
        if (event.type === 'T-102' || event.type === 102) {
          event.icon = <SparklesIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-cyan-200" aria-hidden="true" />
        }
        if (event.type === 'L-201' || event.type === 201) {
          event.icon = <CloudArrowUpIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-gray-100" aria-hidden="true" />
        }
        if (event.type === 'L-202' || event.type === 202) {
          event.icon = <CloudIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-cyan-200" aria-hidden="true" />
        }
        if (event.type === 'C-001') {
          event.icon = <CheckCircleIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-white" aria-hidden="true" />
        }
        if (event.type === 'U-001') {
          event.icon = <CodeBracketIcon className="rounded-lg h-8 w-8 bg-cyan-300 text-white" aria-hidden="true" />
        }
      });
      setSelectedFlow(flow);
    }
    
  }
  if (!props.selectedWorkspace.PK) {
    return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <h1 className="display-4">No Workspace Selected</h1>
                <p className="lead">Please select a workspace from the dropdown above.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  } 
  if (selectedWorkspace && selectedEnvironment) {
    return (
    <div>
      { !selectedFlow.SK && (<>
        <header className="bg-gray-800 shadow-sm pr-4 min-w-0 md:flex md:items-center">
          <PageHeading title="Workflows" />
            <div className="flex w-full justify-end">
              {(selectedWorkspace.environments.length > 0) &&
                <EnvironmentDropdown
                  user={props.user}
                  account={props.account}
                  admin={props.admin}
                  setShowEnvironmentDropdown={props.setShowEnvironmentDropdown}
                  environments={props.environments}
                  selectedWorkspace={selectedWorkspace}
                  updateBillingCustomer={props.updateBillingCustomer}
                  selectedEnvironment={selectedEnvironment}
                  selectedAccount={props.selectedAccount}
                  setSelectedEnvironment={updateEnvironment}
                  logout={props.logout}
                />
              }
              <ActionButton title="Create" icon={SquaresPlusIcon} clickHandler={() => {props.newWorkflowClickHandler()}} />
          </div>
        </header>
          {showAccessAlert && ( <MaximumNumberWorkflowsAlert closeProdRequiredAlert={closeProdRequiredAlert} /> )}
          <ConfirmModal
            isOpen={isModalOpen}
            onClose={closeModal}
            onConfirm={() => confirmDelete()}
            title="Confirm Delete Workflow"
            message={`Are you sure you want to delete ${currentWorkflow?.flowName}?`}
          />
          { !loading &&
            <div className="mt-5 px-4 grid gap-2 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4">
            { workflows.length < 1 && 
              <div className="text-2xl sm:col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-3 2xl:col-span text-center text-gray-300">
                  <p>You don't have any workflows in this workspace environment.</p>
              </div>  
            }
            { workflows?.map((flow: any) => {
              return (
                <div key={flow.SK} className="relative text-gray-200 bg-gray-800 pt-3 px-3 pb-8 sm:pt-3 sm:px-3 rounded-lg overflow-hidden hover:border-cyan-300 border-2 border-gray-600" >
                  <div className="mb-4">
                    <dt>
                      {flow.icon && 
                        <div className="absolute rounded-md pt-1">
                          <flow.icon className="h-8 w-8 text-gray-50 bg-cyan-400 rounded p-1 ring-1 ring-cyan-500 ring-offset-1 ring-offset-cyan-200" />
                        </div>
                      }
                      {!flow.icon && flow.environment?.name.substring(0,3) != "Dev" && (
                        <div className="absolute rounded-md pt-1">
                          <BoltIcon className="h-8 w-8 text-gray-50 bg-cyan-400 rounded p-1 ring-1 ring-cyan-500 ring-offset-1 ring-offset-cyan-200" />
                        </div>
                      )}
                      {!flow.icon && flow.environment?.name.substring(0,3) == "Dev" && (
                        <div className="absolute rounded-md pt-1">
                          <BoltIcon className="h-8 w-8 text-gray-50 bg-gray-500 rounded p-1 ring-1 ring-gray-600 ring-offset-1 ring-offset-gray-300" />
                        </div>
                      )}
                      <div className="cursor-pointer pl-10 mr-5">
                        <p onClick={() => { editFlow(flow); }} className="text-3xl font-semibold text-gray-200 truncate pr-2"> {flow.flowName} </p>
                      </div>
                      <button className="absolute top-0 right-0 m-2 border-gray-500 border hover:bg-orange-500 hover:text-white hover:border-orange-500 text-gray-500 font-bold text-xs py-1 px-2 rounded focus:outline-none focus:shadow-outline"
                        onClick={() => { openModal(flow); }}>X</button>
                    </dt>
                    <dd className="absolute top-9 right-2 pl-2 flex items-baseline">
                      <p className="text-xl font-semibold text-cyan-300">
                        {flow.successes}
                      </p>
                      <p className="ml-0 flex text-xs pr-2 border-r-gray-500 border-r-2">
                        <ArrowUpCircleIcon
                          className="self-center flex-shrink-0 h-5 w-5 pt-1 text-cyan-300"
                          aria-hidden="true"
                        />
                      </p>
                      <p className="text-xl ml-0 font-semibold text-gray-300 pl-2">
                        <span className="text-xl font-semibold text-orange-500">
                          {" "}
                          {flow.failures}
                        </span>
                      </p>
                      <p className="ml-0 flex text-xs align-base">
                        <ExclamationCircleIcon
                          className="self-center pt-1 flex-shrink-0 h-5 w-5 text-orange-500"
                          aria-hidden="true"
                        />
                      </p>
                    </dd>
                    <p className="text-xs ml-0 pl-0 mt-2 w-3/4 pr-1 text-gray-200 truncate">
                      {flow.trigger.type.toUpperCase()} -&gt; &nbsp;
                      {flow.next.type}
                    </p>
                    <p className="text-xs ml-0 pl-0 mb-2 mt-0.5 w-3/4 pr-1 text-gray-200 truncate">
                      Capture Formula:&nbsp;
                      { Object.entries(flow.trigger.custom).map(([key, value], i) => {
                        return (
                          <span key={key}>
                            <span className="border rounded-sm bg-gray-600 border-pink-400 px-0.5">{key}</span>
                            { i < Object.keys(flow.trigger.custom).length - 1 ? " + " : "" }
                          </span>
                        );
                      })
                      }
                    </p>
                  </div>
                  <div className="absolute bottom-0 inset-x-0 bg-gray-600 px-4 py-2 sm:px-6">
                    <div className="text-sm text-center">
                      <button className="font-medium text-gray-200 hover:text-cyan-300" onClick={ () => { viewEvents(flow); }}>
                        Latest Events
                        <span className="sr-only">{" "}{flow.flowName} events</span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          }
        </>
      )}
      { selectedFlow.SK && (
        <div>
          <header className="bg-gray-900 shadow-sm pr-4 min-w-0 md:flex md:items-center">
            <PageHeading className="inline" title={`${selectedFlow.flowName} Event History`} />
            <div className="flex min-w-2 grow-1">
              <div className="inline">
                <button type="button" onClick={() => { setSelectedFlow({events: [], flowName: '', SK: '', environment: ''}); }}
                  className="items-center px-4 py-2 border border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-200 bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300"
                >
                  Back
                </button>
              </div>
            </div>
          </header>
          <ul className="overflow:scroll my-6 pb-6 lg:mx-64 sm:px-2 md:mx-24 mx-24 px-12 bg-gray-800 border rounded-md">
            {!selectedFlow.events && 
            <h2 className="text-center text-gray-200 text-xl py-24">Events will start appearing when messages are processed by this workflow.</h2>
            }
            { selectedFlow?.events.sort((a: any, b: any) => (a.timestamp < b.timestamp ? 1 : -1)).map((event: any) => (
              <li key={event.id}>
                <div className="relative py-4 mx-4">
                  <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-600" aria-hidden="true" />
                  <div className="relative flex space-x-2">
                    <div><span className="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-gray-600">{event.icon}</span></div>
                    <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-1">
                      <div>
                        <p className="text-sm pl-2 text-gray-300">
                          {event.message}{" "}
                        </p>
                      </div>
                      <div className="text-sm whitespace-nowrap text-gray-500">
                        <time dateTime={event.timestamp}>
                          {moment(event.timestamp).format(
                            "dddd, MMMM Do YYYY, h:mm:ss a"
                          )}
                        </time>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>);
  }
}
